import AxiosInstance from "../axiosInstance"; 

export const getWorkTypeList = async (no_userd_cached) => {
    const cached = localStorage.getItem("workTypeList");
  
    if (!no_userd_cached &&cached) {
      try {
        const storedList = JSON.parse(cached);
        if (storedList.length > 0) {
          return storedList;
        }
      } catch (e) {
        console.error("Error parsing workTypeList from localStorage", e);
      }
    }
  
    const transformData = (items) =>
      items
        .map(({ id, name }) => ({
          value: id,
          label: name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
  
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_WORKTYPE_HIGHWAY}`
      );
      const list = transformData(response.data?.data || []);
      localStorage.setItem("workTypeList", JSON.stringify(list));
      return list;
    } catch (error) {
      console.error("Failed to fetch work types:", error?.message);
      return [];
    }
  };
  
  